function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCategory = function SvgCategory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_534",
    "data-name": "Group 534",
    transform: "translate(2012 -10786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_263",
    d: "M115.689 75.184h-2.019v-2.951a.156.156 0 0 0-.155-.155H108.7v-1.864h2.1a.312.312 0 0 0 .311-.311v-5.592A.312.312 0 0 0 110.8 64h-5.6a.312.312 0 0 0-.311.311V69.9a.312.312 0 0 0 .311.311h2.1v1.864h-4.816a.156.156 0 0 0-.155.155v2.951h-2.019a.312.312 0 0 0-.31.319v5.592a.312.312 0 0 0 .311.311h5.589a.312.312 0 0 0 .311-.311V75.5a.312.312 0 0 0-.311-.311h-2.175v-1.713h8.544v1.709H110.1a.312.312 0 0 0-.311.311v5.592a.312.312 0 0 0 .311.311h5.592a.312.312 0 0 0 .311-.311V75.5a.312.312 0 0 0-.314-.316zm-10.951 1.476v3.262h-3.262V76.66zm1.631-7.922v-3.262h3.262v3.262zm8.155 11.184h-3.262V76.66h3.262z",
    "data-name": "Path 263",
    transform: "translate(-2108 10725)",
    style: {
      fill: "#d35400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_466",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 466",
    transform: "translate(-2012 10786)",
    style: {
      fill: "none"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCategory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/category.92fc8300.svg";
export { ForwardRef as ReactComponent };